import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const LoginRegReact = () => {
  useEffect(() => {
    document.title = "Login & Registration Page — Viktoriia Yashkina";
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.75, ease: "easeOut" }}
      className="body"
    >
      <div className="portfolioContainer">
        <div className="pt-12">
          <Link to="/portfolio" className="backLink">
            Back
          </Link>
          <h2 className="h2PortfolioProject">
            portfolio — login & Registration Page
          </h2>{" "}
          <div className="portfolioContext">
            <div className="textContainer">
              <p>
                Since my coding learning is too slow (I was taking on too much),
                I arranged a personal coding marathon for a whole week. The main
                goal - do one project per day from 28.06.2023 to 04.07.2023.
              </p>
              <p>
                This is my third project in this marathon - Login / Registration
                Page. As I said in the project description, it's a very simple
                React project where I didn't use anything special, like a
                backend or API. I thought about adding validation for inputs,
                but I spent so much time on this one, I am tired. Sorry.
              </p>
              <p className="font-bold">Technology & Resources Used:</p>
              <p>01. React, HTML5, and CSS3</p>
              <p>02. Vercel for hosting</p>
              <p>03. Google Fonts & Google Icons</p>
              <p className="font-bold">Main Links:</p>
              <p>
                01.{" "}
                <a
                  href="https://login-registration-page-react.vercel.app/"
                  className="allLinks"
                  rel="noreferrer"
                  target="_blank"
                >
                  Live Preview
                </a>
              </p>
              <p>
                02.{" "}
                <a
                  href="https://github.com/viktoriia-yash/login-registration-page-react"
                  className="allLinks"
                  rel="noreferrer"
                  target="_blank"
                >
                  GitHub
                </a>
              </p>
            </div>
            <div className="max-w-[300px]"></div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default LoginRegReact;
